const dashboard = angular.module('dashboard', [])

dashboard.config(['$stateProvider', function($stateProvider) {

    const routes = [
        {
            name: 'admin.dashboard',
            url: '/dashboard',
            params: { showGlobalLoading: { dynamic: true, value: false } },
            component: 'dashboard.dashboardComponent'
        }
    ];

    routes.forEach($stateProvider.state);
}]);